/** @jsxImportSource @emotion/react */
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

export const dotsAnimation = keyframes`
  0% { content: ''; }
  25% { content: '.'; }
  50% { content: '..'; }
  75% { content: '...'; }
  100% { content: '...'; }

`;

export const AnimatedTextWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  line-height: 1;
  &::after {
    display: inline-block;
    text-align: left;
    animation: ${dotsAnimation} 1.5s infinite steps(1);
    content: '';
    min-width: 1.5ch;
    overflow: hidden;
    vertical-align: middle;
  }
`;
